import { Action } from 'shared/store/types';
import actionTypes from './actionTypes';
import { GeoSubdivisionState } from './types';

const defaultState: GeoSubdivisionState = {
  loading: false,
  isFetchingError: false,
  geoSubdivisions: [],
};

const geoSubdivisionsReducer = (state = defaultState, action: Action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.FETCH_GEO_LOCATION_DATA_PROGRESS:
      return {
        ...state,
        loading: true,
        isNotFound: false,
        isFetchingError: false,
      };

    case actionTypes.FETCH_GEO_LOCATION_DATA_FAILED:
      return {
        ...state,
        loading: false,
        isNotFound: false,
        isFetchingError: true,
      };

    case actionTypes.FETCH_GEO_LOCATION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        isNotFound: false,
        isFetchingError: false,
        geoSubdivisions: payload,
      };

    default:
      return state;
  }
};

export default geoSubdivisionsReducer;
